import { canSubscribeToChannel } from 'widget/ui-selectors/channel-access';

import getTranslationData from './translation-data';
import getCallbackFromProps from './callback';


export default function getPaidAccessButtonConfig(props) {
  const { channelData } = props;

  if (!canSubscribeToChannel(channelData)) {
    return null;
  }

  const callback = getCallbackFromProps(props);
  const translationData = getTranslationData(channelData);

  return {
    callback,
    translationData,
  };
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/paid-access/button-config.js